/* eslint-disable prettier/prettier */

import enLocale from 'element-ui/lib/locale/lang/en';
import zhLocale from 'element-ui/lib/locale/lang/zh-CN';

// elementui 语言包
const elementLocaleMessage = {
  'zh-CN': zhLocale,
  'en-US': enLocale
};

let xpcConfig = {
  address: {
    provinceUrl: 'http://demo.recloud.com.cn:9901/api/SfaCommon/GetProvinceList',
    cityUrl: 'http://demo.recloud.com.cn:9901/api/SfaCommon/GetCityList',
    countyUrl: 'http://demo.recloud.com.cn:9901/api/SfaCommon/GetCountyList',
    alias: { id: 'Id', name: 'Name' },
    autoLoad: true
  },
  componentPrefix: 'Rt',
  defaultLocale: 'zh-CN',
  defaultLocaleId: '2052',
  localesUrl: 'api/PortalLanguage/GetLanguageList',
  localesMessageUrl: 'api/PortalLanguage/GetLanguageConfigs?langId=',
  defaultIconName: 'rt-base-defaultIcon',
  elementLocaleMessage
};

const _ = {};
_.get = () => {
  return xpcConfig;
};
_.assign = mergeConfig => {
  let mergeElementLocaleMessage = Object.assign(xpcConfig.elementLocaleMessage, mergeConfig.elementLocaleMessage);
  xpcConfig = Object.assign(xpcConfig, mergeConfig);
  xpcConfig.elementLocaleMessage = mergeElementLocaleMessage;
  return xpcConfig;
};
_.set = (key, value) => {
  xpcConfig[key] = value;
};

export default _;



// WEBPACK FOOTER //
// ./~/vue-xpc/src/config.js